import React from 'react';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';

import styles from './PlusAllFeatures.module.scss';
import ValuePropsBox from '../ValuePropsBox';
import { ReactComponent as IconStats } from '../../../../../assets/images/icons/icon_stats.svg';
import { ReactComponent as IconBell } from '../../../../../assets/images/icons/icon_bell.svg';
import { ReactComponent as IconTracking } from '../../../../../assets/images/icons/icon_tracking.svg';
import { ReactComponent as IconBarking } from '../../../../../assets/images/icons/icon_barking.svg';
import { ReactComponent as IconScratching } from '../../../../../assets/images/icons/icon_scratching.svg';
import { ReactComponent as IconEating } from '../../../../../assets/images/icons/icon_eating.svg';
import { ReactComponent as IconVet } from '../../../../../assets/images/icons/icon_vet_black.svg';
import { ReactComponent as IconHealthTrend } from '../../../../../assets/images/icons/icon_health_trend.svg';
import { ReactComponent as IconLight } from '../../../../../assets/images/icons/icon_light.svg';
import { ReactComponent as IconCar } from '../../../../../assets/images/icons/icon_car.svg';
import { ReactComponent as IconGroups } from '../../../../../assets/images/icons/icon_groups.svg';
import { ReactComponent as IconCheckCircleFilled } from '../../../../../assets/images/icons/check_circle_filled.svg';
import { isMobileDevice } from '../../../../../lib/util/isMobileDevice';

function getFeatureProps(t: TFunction) {
  return [
    {
      icon: <IconTracking className={styles.icon} />,
      text: <div className={styles.valueProp}>{t('gps_lte_m_live_tracking')}</div>,
    },
    {
      icon: <IconBell />,
      text: <div className={styles.valueProp}>{t('geofence_escape_alerts')}</div>,
    },
    {
      icon: <IconCar />,
      text: <div className={styles.valueProp}>{t('walks_car_rides')}</div>,
    },
    {
      icon: <IconVet style={{ color: 'black' }} />,
      text: <div className={styles.valueProp}>{t('smart_vet_records')}</div>,
    },
    {
      icon: <IconLight />,
      text: <div className={styles.valueProp}>{t('night_light')}</div>,
    },
    {
      icon: <IconHealthTrend />,
      text: <div className={styles.valueProp}>{t('health_ai_agent')}</div>,
    },
    {
      icon: <IconStats />,
      text: <div className={styles.valueProp}>{t('activity_sleep_analysis')}</div>,
    },
    {
      icon: <IconEating />,
      text: <div className={styles.valueProp}>{t('eating_drinking_detection')}</div>,
    },
    {
      icon: <IconScratching />,
      text: <div className={styles.valueProp}>{t('scratching_licking_monitoring')}</div>,
    },
    {
      icon: <IconBarking />,
      text: <div className={styles.valueProp}>{t('barking_alerts')}</div>,
    },
    {
      icon: <IconGroups />,
      text: <div className={styles.valueProp}>{t('unlimited_users')}</div>,
    },
  ];
}

interface PlusAllFeaturesProps {
  containerRef?: React.RefObject<HTMLDivElement>;
  freeTrialEnabled?: boolean;
}

export default function PlusAllFeatures({ containerRef, freeTrialEnabled }: PlusAllFeaturesProps) {
  const { t } = useTranslation();
  const isMobile = isMobileDevice();

  const featureProps = getFeatureProps(t);

  // Add "Free Trial Available" feature when free trial is enabled
  if (freeTrialEnabled) {
    featureProps.push({
      icon: <IconCheckCircleFilled />,
      text: <div className={styles.valueProp}>{t('free_trial')}</div>,
    });
  }

  return (
    <div ref={containerRef} className={styles.container}>
      <h2 className={styles.heading}>{t('all_features')}</h2>
      <div className={styles.valueProps}>
        <ValuePropsBox compact={!isMobile} columns={2} valueProps={featureProps} />
      </div>
    </div>
  );
}
